export default __webpack_public_path__ + "static/media/Bici da Corsa.7457d033.jpg";